// Порт ref SubBlockSettingsEditor:520-566: загрузка через наш CDN-загрузчик
// (`ImageUpload` уже умеет превью + удаление) + слайдер поворота ±4°.
import { Label } from '@teach/ui'
import type { DesignImage } from '@/types/blocks'
import { DESIGN_LIMITS } from '@/features/editor/lib/designElements'
import { useContentLang } from '@/features/editor/hooks/useContentLang'
import { getLocalizedField, setLocalizedField } from '@/features/editor/lib/localizedField'
import { readPrompt, writePrompt } from '@/features/editor/lib/imagePrompt'
import { RotationSlider } from './RotationSlider'
import { HintBox } from './HintBox'
import { ImageUpload } from '@/features/editor/components/shared/ImageUpload'
import { ImagePromptField } from '@/features/editor/components/shared/ImagePromptField'
import { useDesignImageTarget } from './useDesignImageTarget'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  element: DesignImage
  onUpdate: (patch: Partial<DesignImage>) => void
}

export const ImageSettings = ({ element, onUpdate }: Props) => {
  const m = useMessages(messages)
  const contentLang = useContentLang()
  const value = getLocalizedField(element, 'imageUrl', contentLang) || null
  const imageTarget = useDesignImageTarget(element, contentLang)

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{m.image}</Label>
        <ImageUpload
          value={value}
          onChange={(url) => onUpdate(setLocalizedField('imageUrl', contentLang, url ?? ''))}
          blockTarget={imageTarget}
        />
        {/* Подсказка нужна до загрузки: с готовой картинкой автор уже видит результат. */}
        {value ? null : <HintBox>{m.imageHint}</HintBox>}
        <ImagePromptField
          value={readPrompt(element, contentLang)}
          hasImage={Boolean(value)}
          onChange={(next) => onUpdate(writePrompt(contentLang, next))}
        />
      </div>

      {/* Наклонять пока нечего — без картинки контрол только сбивает. */}
      {value ? (
        <RotationSlider
          label={m.tilt}
          value={element.imageRotation}
          limit={DESIGN_LIMITS.IMAGE_ROTATION}
          onChange={(imageRotation) => onUpdate({ imageRotation })}
        />
      ) : null}
    </div>
  )
}
